import React, { FC } from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../../../../../ui';
import { Logo } from '../../../../../shared/components';
import { getPoiImageUrl } from './helpers/getPoiImageUrl';
import { IPoi } from '../../../../domain/models/IPoi';
import themed from '../../../../../../ui/themer/themed';
import Responsive from '../../../../../../ui/utils/Responsive';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

interface IItemImageProps {
	image?: string | null;
	poi?: IPoi;
}

export const ItemImage: FC<IItemImageProps> = ({ image, poi }) => {
	const { t } = useTranslation();

	return image ? (
		<StyledItemImage
			src={getPoiImageUrl(image)}
			alt={poi ? '' : t('shop_dine_relax_poi_alt')}
		/>
	) : (
		<ItemImagePlaceholder />
	);
};

const IMAGE_SIZE_DESKTOP = '180px';
const IMAGE_SIZE_MOBILE = '90px';

const StyledItemImagePlaceholder = styled.div<{}, ITheme>`
	flex-shrink: 0;
	width: ${IMAGE_SIZE_DESKTOP};
	height: ${IMAGE_SIZE_DESKTOP};
	line-height: ${IMAGE_SIZE_DESKTOP};
	background: ${themed(({ background }) => background.light)};
	text-align: center;

	${Logo} {
		display: inline-block;
		width: 120px;
		height: auto;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: ${IMAGE_SIZE_MOBILE};
		height: ${IMAGE_SIZE_MOBILE};
		line-height: ${IMAGE_SIZE_MOBILE};

		${Logo} {
			width: 60px;
			height: auto;
		}
	}
`;

const ItemImagePlaceholder = () => (
	<StyledItemImagePlaceholder>
		<Logo />
	</StyledItemImagePlaceholder>
);

const StyledItemImage = styled.img<{}, ITheme>`
	display: block;
	flex-shrink: 0;
	width: ${IMAGE_SIZE_DESKTOP};
	height: ${IMAGE_SIZE_DESKTOP};
	background: ${themed(({ background }) => background.light)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: ${IMAGE_SIZE_MOBILE};
		height: ${IMAGE_SIZE_MOBILE};
	}
`;
